import { render, staticRenderFns } from "./VeHrChangeTypeList.vue?vue&type=template&id=13ca4a0a&scoped=true"
import script from "./VeHrChangeTypeList.vue?vue&type=script&lang=js"
export * from "./VeHrChangeTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca4a0a",
  null
  
)

export default component.exports